import { MatrixClass }  from "@models/matrix-class"
import { ClassesManagerState } from "../states/classes-manager"
import { Course } from "@models/course"
import { Contact } from "@models/contact"

export class MatrixClassesStore {
  constructor(
    public matrixClasses: MatrixClass[] = [],
    public editableClass: MatrixClass = new MatrixClass(),
    public activeClass: MatrixClass = new MatrixClass(),
    public teachers: Contact[] = [],
    public classesManagerState: ClassesManagerState = new ClassesManagerState(),
    public classesRolloverTermFrom: MatrixClass[] = [],
    public classesRolloverTermTo: MatrixClass[] = [],
    public classRolloverResult: MatrixClass[] = [],
  ) {}
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/matrix-classes.ts